import consts from "./_consts";
export default {
  name: "dashboardIndex",
  path: "/",
  items: {
    clientAdminHome: {
      name: " Home ",
      url: "/home",
      icon: consts.iconNames.home
    },
    programs: {
      name: "My Programs",
      url: "/programs",
      entity: ["program"],
      permissionName: "prog__program__index",
      icon: consts.iconNames.program,
      children: {
        program_create: {
          name: "program_create",
          url: "/programs/create",
          hidden: true
        },
        program_info: {
          name: "program_info",
          url: "/programs/:id/info",
          hidden: true
        },
        program_date: {
          name: "program_date",
          url: "/programs/:id/date",
          hidden: true
        },
        program_structure_points: {
          name: "program_structure_points",
          url: "/programs/:id/structure-points",
          hidden: true
        },
        program_milestone_settings: {
          name: "program_milestone_settings",
          url: "/programs/:id/milestone_settings",
          hidden: true
        },
        program_milestone_rewards_completion: {
          name: "program_milestone_rewards_completion",
          url: "/programs/:id/milestone-completion-rewards",
          hidden: true
        },
        program_outcomes: {
          name: "program_outcomes",
          url: "/programs/:id/outcomes",
          hidden: true
        },
        program_cohorts: {
          name: "program_cohorts",
          url: "/programs/:id/cohorts",
          hidden: true
        },
        program_appeals_form: {
          name: "program_appeals_form",
          url: "/programs/:id/appeals-form",
          hidden: true
        },
        program_tobacco: {
          name: "program_tobacco",
          url: "/programs/:id/tobacco",
          hidden: true
        },
        program_points: {
          name: "program_points",
          url: "/programs/:id/points",
          hidden: true
        },
        program_level_rewards: {
          name: "program_level_rewards",
          url: "/programs/:id/level-rewards",
          hidden: true
        },
        program_summary: {
          name: "program_summary",
          url: "/programs/:id/program-summary",
          hidden: true
        },
        program_activity: {
          name: "program_activity",
          url: "/programs/:id/activities",
          hidden: true
        },
        program_level_paths: {
          name: "program_level_paths",
          url: "/programs/:id/level-paths",
          hidden: true
        },
        program_level_practices: {
          name: "program_level_practices",
          url: "/programs/:id/level-practices",
          hidden: true
        },
        program_level_activities: {
          name: "program_level_activities",
          url: "/programs/:id/level-activities",
          hidden: true
        },
        program_ras_activities: {
          name: "program_ras_activities",
          url: "/programs/:id/ras-activities",
          hidden: true
        },
        program_ras_paths: {
          name: "program_ras_paths",
          url: "/programs/:id/ras-paths",
          hidden: true
        },
        program_activity_view: {
          name: "program_activity_view",
          url: "/programs/:id/activities/:aid/view",
          hidden: true
        },
        program_level_activity_view: {
          name: "program_level_activity_view",
          url: "/programs/:id/level-activities/:aid/view",
          hidden: true
        },
        program_collections: {
          name: "program_collections",
          url: "/programs/:id/collections",
          hidden: true
        },
      }
    },
    eligibility: {
      name: " Eligible Population ",
      url: "/employees",
      permissionName: "em__employee__index",
      icon: consts.iconNames.eligiblePopulation,
      children: {
        add_new_employee: {
          name: "dashboard-add-new-employee",
          url: "/employees/add-new"
        },
        edit_employee: {
          name: "dashboard-edit-employee",
          url: "/employees/:id/edit"
        },
        reward_history: {
          name: "dashboard-reward-history",
          url: "/employees/:id/reward-history"
        }
      }
    },
    incentiveProcessing: {
      name: "Incentive Processing",
      url: "/incentive-processing",
      permissionName: "em__employee__upload_incentive",
      icon: consts.iconNames.testupload
    },
    userProvisioning: {
      name: "Users",
      url: "/client-users",
      permissionName: "cc__user_client_admin__index",
      icon: consts.iconNames.user,
      children: {
        clientAdmins: {
          name: "Users",
          path: "/client-users/list"
        },
        clientAdminsAdd: {
          name: "Add User",
          path: "/client-users/add"
        },
        clientAdminsEdit: {
          name: "Edit User",
          path: "/client-users/edit/:id"
        },
        needsReview: {
          name: "Needs Review",
          path: "/client-users/needs-review"
        },
        changeLog: {
          name: "Change Log",
          path: "/client-users/change-log"
        }
      }
    },
    sisense: {
      name: "Reports",
      url: "/reports",
      permissionName: "sisense__report__access_to_sisense",
      icon: consts.iconNames.reports
    },
    extracts: {
      name: "Extracts",
      url: "/extracts",
      permissionName: "cc__extracts__index",
      icon: consts.iconNames.extracts,
    },
    faqs: {
      name: "FAQs",
      url: "/faqs",
      permissionName: "",
      icon: consts.iconNames.faq
    },
    userManagement: {
      name: "Dashboard User Management",
      path: "/dashboard/user-management",
      permissionName: "",
      entity: ["user"],
      hidden: true,
      children: {
        profile: {
          name: "Dashboard Profile",
          path: "/dashboard/user-management/profile"
        },
        changePassword: {
          name: "Dashboard Change Password",
          path: "/dashboard/user-management/change-password"
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/_nav.js